<template>
  <v-badge
    color="red"
    :inline="inline"
    :content="unreadCountString"
    :model-value="isBadgeVisible"
    :offset-x="offsetX"
  >
    <slot />
  </v-badge>
</template>

<script lang="ts">
import useRealmSettings from '@src/composables/realmSettings'
import useWhatsNew from '@src/composables/whatsNew'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'SMWhatsNewBadge',
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    offsetX: {
      type: String,
      default: '20'
    }
  },
  setup() {
    const { isWhatsNewEnabled } = useRealmSettings()
    const { unreadCountString } = useWhatsNew()
    const isBadgeVisible = computed(() => isWhatsNewEnabled.value && !!unreadCountString.value)

    return {
      isBadgeVisible,
      unreadCountString
    }
  }
})
</script>
